import ProjectSession from "./project-session"
import {SpaceProto} from "../space/space-proto"

// const debug = 'Section'
const debug = false

export default class Section extends SpaceProto {

    public readonly project: ProjectSession

    constructor(project:ProjectSession) {
        super('section-'+project.id)

        this.project = project
    }

    get rootProjects() {
        return this.project.treeChildren
    }

    get isSection(): boolean {
        return true
    }

    // collect all sections from parent
    private getAllParentSections() {
        return _(this.project.treeParent?.treeChildren)
            .filter((projectSession: ProjectSession) => {
                return projectSession.isSection
            }).orderBy((projectSession: ProjectSession) => {
                return projectSession.sortPosition
            })
            .value()
    }

    // retrieve this section index in ordered sections array
    private getSelfPosition(allParentSections: ProjectSession[]) {
        return _.findIndex(allParentSections, (projectSession: ProjectSession) => {
            return projectSession.id === this.project.id
        })
    }

    get previousSectionProject() {
        const allParentSections = this.getAllParentSections()
        const selfPosition = this.getSelfPosition(allParentSections)

        // determine previous section position
        const previousSectionPosition = selfPosition - 1

        // return previous section if any
        return previousSectionPosition >= 0 ? allParentSections[previousSectionPosition] : null
    }

    get nextSectionProject() {
        const allParentSections = this.getAllParentSections()
        const selfPosition = this.getSelfPosition(allParentSections)

        // determine next section position
        const nextSectionPosition = selfPosition + 1

        // return next section if any
        return nextSectionPosition <= allParentSections.length - 1 ? allParentSections[nextSectionPosition] : null
    }
}
